<template>
    <b-overlay :show="saveLoading" spinner-small spinner-variant="secondary">
        <click-edit :default-value="`ID:${id}`"
                    :value-label="`ID:${id}→Code: `"
                    :value.sync="dictCode.name" @inputBlur="doSave"/>
    </b-overlay>
</template>

<script>
import {DICT_TYPE} from "@/plugins/configure-query-helper.js"
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import ClickEdit from "@/components/common/inputs/ClickEdit.vue";

export default {
    name: "IdRecode",
    components: {ClickEdit},
    mixins: [emCommonUtilMixin],
    props: {
        id: Number,
        service: String,
        codeConfig: Array,
    },
    data() {
        return {
            dictCode: {},
            saveLoading: false,
        }
    },
    watch: {
        id: {
            handler() {
                this.queryCode();
            },
            immediate: true
        },
        codeConfig: {
            handler() {
                this.queryCode();
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        getCode(config) {
            let temp = this.service + ":" + this.id;
            let got = false;
            if (config) {
                for (let item of config) {
                    if (item.value === temp) {
                        // 拷贝一份，避免编辑中的 name 经 .sync 写回父组件的快照，导致保存失败后无法还原
                        this.dictCode = {...item};
                        got = true;
                        break;
                    }
                }
            }
            if (!got) {
                this.dictCode = {value: temp};
            }
        },
        queryCode() {
            if (this.id && this.service) {
                if (this.codeConfig) {
                    this.getCode(this.codeConfig);
                } else {
                    this.$store.dispatch('api/get', {
                        url: `${this._baseUrl('emDictData')}simple/${DICT_TYPE}/query`
                    }).then(res => {
                        this.getCode(res);
                    });
                }
            }
        },
        doSave() {
            if (this.saveLoading || !this.dictCode || !this.hasCode(this.dictCode.name)) {
                return;
            }
            this.saveLoading = true;
            this.$store.dispatch('api/post', {
                url: `${this._baseUrl('emDictData')}simple/${DICT_TYPE}/edit`,
                data: {
                    editRows: [this.dictCode]
                }
            }).then(() => {
                // Tell the parent to reload its shared config so the new value is reflected.
                this.$emit('saved');
                // When codeConfig is provided it's a stale snapshot owned by the parent;
                // re-querying it here would just revert the cell. Only self-refresh when we
                // own the data (server query path).
                if (!this.codeConfig) {
                    this.queryCode();
                }
            }).catch(() => {
                // 被后端拒绝（如私有配置不允许配 Code）时把单元格恢复成已保存的值，错误提示由全局处理弹出
                this.queryCode();
            }).finally(() => this.saveLoading = false);
        },
    }
}
</script>

<style scoped>

</style>
